import { __read } from "tslib";
import { useState } from 'react';
export var useScheduleModal = function () {
    var _a = __read(useState('list'), 2), type = _a[0], setType = _a[1];
    return { type: type, setType: setType };
};
